import PropTypes from 'prop-types'
import { useTheme } from '@emotion/react'
import { ListItem, Inline } from 'chaoskit/src/components'

import {
  HomeHero,
  HomeHeroGrid,
  HomeHeroGridImage,
  HomeHeroGridContent,
} from '~partials/home/Hero'
import ButtonLink from '~components/ButtonLink'
import Data from '~components/Data'
import CustomerLogos from '~partials/global/CustomerLogos'
import Image from '~components/Image'
import { HeroTitle, HeroTitleSub, HeroContent } from '~partials/Hero'

const IndustryHero = ({ image, heading, blurb, seoRef, ctaRoute }) => {
  const theme = useTheme()

  return (
    <HomeHero>
      <HeroContent>
        <HomeHeroGrid>
          <HomeHeroGridImage>
            <Image src={image} alt="" />
          </HomeHeroGridImage>
          <HomeHeroGridContent>
            <HeroTitle size="large">
              <Data>{heading}</Data>
            </HeroTitle>
            <HeroTitleSub>
              <Data>{blurb}</Data>
            </HeroTitleSub>
            <div css={{ marginTop: theme.space.large }}>
              <Inline
                css={{
                  justifyContent: 'center',

                  [theme.mq.medium]: {
                    justifyContent: 'flex-start',
                  },
                }}
              >
                <ListItem>
                  <ButtonLink
                    noContrast
                    type="primary"
                    url={ctaRoute || `/get-started/?ref=${seoRef}`}
                  >
                    Get started
                  </ButtonLink>
                </ListItem>
                <ListItem>
                  <ButtonLink
                    type="default"
                    url={`/weekly-live-demo/?ref=${seoRef}`}
                  >
                    Weekly live demo
                  </ButtonLink>
                </ListItem>
              </Inline>
            </div>
          </HomeHeroGridContent>
        </HomeHeroGrid>
        <CustomerLogos
          css={{ paddingBottom: `${theme.space.base}px !important` }}
          contrast
        />
      </HeroContent>
    </HomeHero>
  )
}

IndustryHero.propTypes = {
  ctaRoute: PropTypes.string,
  blurb: PropTypes.string.isRequired,
  heading: PropTypes.string.isRequired,
  image: PropTypes.string.isRequired,
  seoRef: PropTypes.string.isRequired,
}

export default IndustryHero
